import * as React from "react"
import { useLocation } from '@reach/router'
import { 
    GetLocalImageFromUrl,
    CapitalizeLastTwo 
} from '../utils/globalUtils.js'
import { useStaticQuery, graphql } from "gatsby"
import defaultOgImg from '../images/default-og.jpg'

const SEOhead = (props) => {
    const location = useLocation()
    const query = useStaticQuery(graphql`
        query allUriCheck {
            allWpPost {
                nodes {
                    uri
                }
            }
            allWpPage {
                nodes {
                    uri
                }
            }
        }
    `)
    let uriCollection = []

    query.allWpPost.nodes.forEach(node => {
        uriCollection.push(node.uri)
    })
    
    query.allWpPage.nodes.forEach(node => {
        uriCollection.push(node.uri)
    })

    let { 
        metaDesc,
        metaRobotsNofollow,
        metaRobotsNoindex,
        opengraphUrl,
        opengraphType,
        opengraphAuthor,
        opengraphDescription,
        opengraphImage,
        opengraphTitle,
        title,
        twitterDescription,
        twitterTitle,
        schema
    } = props.data
    let jsonLD  = ( props.customJsonLD !== '' ) ? 
        props.customJsonLD : schema.raw
    let ogImage = ( props.hasFeaturedImage && opengraphImage ) ? 
        opengraphImage.localFile.publicURL : defaultOgImg

    let locale    = props.data.locale || 'en_US'
    let langCode  = locale.replace('_','-')
    let allLangs  = props.data.allLangs || []
    let altLangs  = allLangs.filter(lang => lang !== locale)
    let transUris = props.data.transUris || []
    let baseLocale = [
        ['en', 'es'],
        ['', '']
    ]
    let xDefault = false

    // Remove when have translated blog and news START
    if ( location.pathname
        .match(/\/(company-blog|blog|news-press-releases)\//))
            transUris = []

    // Remove when have translated blog and news END

    transUris.forEach((uri) => {
        if ( !uri.match(/\/[a-z]{2}-[a-z]{2}\//) ) {
            xDefault = uri
            baseLocale[1][0] = uri
        }

        if ( uri.match(/\/es-pe\//) )
            baseLocale[1][1] = uri

    })
    
    if ( xDefault === false ) {
        if ( location.pathname.match(/\/[a-z]{2}-[a-z]{2}\//) ) {
            xDefault = false
            baseLocale[1][0] = false

        } else {
            xDefault = location.pathname
            baseLocale[1][0] = location.pathname

        }
    }

    if ( !baseLocale[1][1] && location.pathname.match(/\/es-[a-z]{2}\//) )  
        baseLocale[1][1] = location.pathname

    ogImage = process.env.GATSBY_FQDN + ogImage

    let wpUrls = ( jsonLD ) ? 
        [...new Set(jsonLD.match(/https:\/\/grmdevelop(.*?)"/g))] :
        ''
    
    if ( wpUrls[0] ) 
        wpUrls.forEach(url => {
            url = url.replace('"','')
            let newUrl = GetLocalImageFromUrl(url)
    
            if ( newUrl !== false )
                jsonLD = jsonLD
                    .replaceAll(
                        url, 
                        newUrl
                    )
        })

    if ( jsonLD ) {
        jsonLD = jsonLD.replaceAll(
            /":"\//g, 
            '":"'+ process.env.GATSBY_FQDN +'/'
        )
    
        jsonLD = jsonLD.replaceAll(
            '["/',
            '["'+ process.env.GATSBY_FQDN +'/'
        )
    }
    
    opengraphTitle = opengraphTitle || title 
    opengraphDescription = opengraphDescription || metaDesc

    twitterTitle = twitterTitle || title 
    twitterDescription = twitterDescription || metaDesc

    return (
        <>
            <html lang={langCode} />
            <title>{title}</title>
            

            {
                xDefault &&
                <link rel="alternate" hrefLang="x-default" 
                    href={ process.env.GATSBY_FQDN + xDefault } />

            }
            {
                transUris &&
                transUris.map((uri) => {
                    let langFromUri = uri.split('/')[1]
                    let lang = ( langFromUri.match(/[a-z]{2}-[a-z]{2}/) &&
                            langFromUri.length === 5 ) ? 
                        CapitalizeLastTwo(uri.split('/')[1]) : 'en-US'

                    return(
                        <link rel="alternate" 
                            href={process.env.GATSBY_FQDN + uri} key={lang}
                            hrefLang={lang} />
                        
                    )
                })
            }
            <link rel="alternate" href={process.env.GATSBY_FQDN + location.pathname} 
                hrefLang={langCode} />

            {
                baseLocale[1].map((baseLang, i) => {
                    if ( baseLang ) {
                        return(
                            <link rel="alternate"  key={baseLocale[0][i]}
                                href={process.env.GATSBY_FQDN + baseLang} 
                                hrefLang={baseLocale[0][i]} />
                        )
                    } else {
                        return null
                    }
                })
            }

            <meta httpEquiv="content-language" 
                content={ langCode.toLowerCase() } />

            {
                metaDesc &&
                <meta name="description"
                    content={ metaDesc } />
            }

            {
                opengraphAuthor &&
                <meta property="author"
                    content={ opengraphAuthor } />
            }
            {
                metaRobotsNofollow &&
                <meta property="robots"
                    content={ metaRobotsNofollow + ',' + metaRobotsNoindex } />
            }
            {/* Open graph */}
            <meta property="og:locale" content={ locale } />
            {
                altLangs &&
                altLangs.map((lang) => (
                    <meta key={lang} property="og:locale:alternate" content={ lang } />
                ))
            }
            {
                opengraphUrl &&
                <meta property="og:url" 
                    content={ opengraphUrl } />
            }
            {
                opengraphType &&
                <meta property="og:type" 
                    content={ opengraphType } />
            }
            {
                opengraphTitle &&
                <meta property="og:title" 
                    content={ opengraphTitle } />
            }
            {
                opengraphDescription &&
                <meta property="og:description" 
                    content={ opengraphDescription } />
            }

            <meta property="og:image" content={ ogImage } />
            
            {/* Twitter meta */}
            {
                twitterTitle &&
                <meta property="twitter:title"
                    content={ twitterTitle } />
            }
            {
                twitterDescription &&
                <meta property="twitter:description"
                    content={ twitterDescription } />
            }
            {
                opengraphUrl &&
                <meta property="twitter:url"
                    content={ opengraphUrl } />
            }

            <meta property="twitter:image"
                content={ ogImage } />

            {
                schema &&
                <script type="application/ld+json">
                    { jsonLD }
                </script> 
            }
        </>
    )
}

export default SEOhead
